// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b1618b1c","160":"3230d12a","198":"02746de7","208":"85f83c10","293":"32cb721e","453":"1862b45e","516":"a8a67e91","519":"fce20be6","917":"0d2344c1","946":"b9be72f5"}[chunkId] + ".chunk.js";
};